/* This file is auto-generated */

import type { ContractPromise } from '@polkadot/api-contract';
import type { KeyringPair } from '@polkadot/keyring/types';
import type { SignerOptions } from '@polkadot/api/submittable/types';
import type { ApiPromise } from '@polkadot/api';
import type { GasLimit, GasLimitAndRequiredValue, Result } from '@arthswap/typechain-types';
import { txSignAndSend } from '@arthswap/typechain-types';
import type * as ArgumentTypes from '../types-arguments/pair_contract';
import type BN from 'bn.js';


export default class Methods {
	private __nativeContract : ContractPromise;
	private __keyringPair : KeyringPair;
	private __apiPromise: ApiPromise;

	constructor(
		apiPromise: ApiPromise,
		nativeContract : ContractPromise,
		keyringPair : KeyringPair,
	) {
		this.__apiPromise = apiPromise;
		this.__nativeContract = nativeContract;
		this.__keyringPair = keyringPair;
	}

	/**
	* totalSupply
	*
	*/
	"totalSupply" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::totalSupply",
			[], __options, __signerOptions);
	}

	/**
	* increaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	*/
	"increaseAllowance" (
		spender: ArgumentTypes.AccountId,
		deltaValue: (string | number | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::increaseAllowance",
			[spender, deltaValue], __options, __signerOptions);
	}

	/**
	* balanceOf
	*
	* @param { ArgumentTypes.AccountId } owner,
	*/
	"balanceOf" (
		owner: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::balanceOf",
			[owner], __options, __signerOptions);
	}

	/**
	* transferFrom
	*
	* @param { ArgumentTypes.AccountId } from,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	*/
	"transferFrom" (
		from: ArgumentTypes.AccountId,
		to: ArgumentTypes.AccountId,
		value: (string | number | BN),
		data: Array<(number | string | BN)>,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transferFrom",
			[from, to, value, data], __options, __signerOptions);
	}

	/**
	* allowance
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @param { ArgumentTypes.AccountId } spender,
	*/
	"allowance" (
		owner: ArgumentTypes.AccountId,
		spender: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::allowance",
			[owner, spender], __options, __signerOptions);
	}

	/**
	* decreaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	*/
	"decreaseAllowance" (
		spender: ArgumentTypes.AccountId,
		deltaValue: (string | number | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::decreaseAllowance",
			[spender, deltaValue], __options, __signerOptions);
	}

	/**
	* transfer
	*
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	*/
	"transfer" (
		to: ArgumentTypes.AccountId,
		value: (string | number | BN),
		data: Array<(number | string | BN)>,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transfer",
			[to, value, data], __options, __signerOptions);
	}

	/**
	* approve
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } value,
	*/
	"approve" (
		spender: ArgumentTypes.AccountId,
		value: (string | number | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::approve",
			[spender, value], __options, __signerOptions);
	}

	/**
	* tokenSymbol
	*
	*/
	"tokenSymbol" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenSymbol",
			[], __options, __signerOptions);
	}

	/**
	* tokenDecimals
	*
	*/
	"tokenDecimals" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenDecimals",
			[], __options, __signerOptions);
	}

	/**
	* tokenName
	*
	*/
	"tokenName" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenName",
			[], __options, __signerOptions);
	}

	/**
	* owner
	*
	*/
	"owner" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::owner",
			[], __options, __signerOptions);
	}

	/**
	* renounceOwnership
	*
	*/
	"renounceOwnership" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::renounceOwnership",
			[], __options, __signerOptions);
	}

	/**
	* transferOwnership
	*
	* @param { ArgumentTypes.AccountId } newOwner,
	*/
	"transferOwnership" (
		newOwner: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::transferOwnership",
			[newOwner], __options, __signerOptions);
	}

	/**
	* getToken0
	*
	*/
	"getToken0" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::getToken0",
			[], __options, __signerOptions);
	}

	/**
	* price1CumulativeLast
	*
	*/
	"price1CumulativeLast" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::price1CumulativeLast",
			[], __options, __signerOptions);
	}

	/**
	* kLast
	*
	*/
	"kLast" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::kLast",
			[], __options, __signerOptions);
	}

	/**
	* factory
	*
	*/
	"factory" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::factory",
			[], __options, __signerOptions);
	}

	/**
	* getReserves
	*
	*/
	"getReserves" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::getReserves",
			[], __options, __signerOptions);
	}

	/**
	* burn
	*
	* @param { ArgumentTypes.AccountId } to,
	*/
	"burn" (
		to: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::burn",
			[to], __options, __signerOptions);
	}

	/**
	* getToken1
	*
	*/
	"getToken1" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::getToken1",
			[], __options, __signerOptions);
	}

	/**
	* initialize
	*
	* @param { ArgumentTypes.AccountId } token0,
	* @param { ArgumentTypes.AccountId } token1,
	*/
	"initialize" (
		token0: ArgumentTypes.AccountId,
		token1: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::initialize",
			[token0, token1], __options, __signerOptions);
	}

	/**
	* mint
	*
	* @param { ArgumentTypes.AccountId } to,
	*/
	"mint" (
		to: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::mint",
			[to], __options, __signerOptions);
	}

	/**
	* skim
	*
	* @param { ArgumentTypes.AccountId } to,
	*/
	"skim" (
		to: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::skim",
			[to], __options, __signerOptions);
	}

	/**
	* sync
	*
	*/
	"sync" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::sync",
			[], __options, __signerOptions);
	}

	/**
	* price0CumulativeLast
	*
	*/
	"price0CumulativeLast" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::price0CumulativeLast",
			[], __options, __signerOptions);
	}

	/**
	* swap
	*
	* @param { (string | number | BN) } amount0Out,
	* @param { (string | number | BN) } amount1Out,
	* @param { ArgumentTypes.AccountId } to,
	* @param { Array<(number | string | BN)> } data,
	*/
	"swap" (
		amount0Out: (string | number | BN),
		amount1Out: (string | number | BN),
		to: ArgumentTypes.AccountId,
		data: Array<(number | string | BN)>,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::swap",
			[amount0Out, amount1Out, to, data], __options, __signerOptions);
	}

}
